"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AdvancedTable_1 = __importDefault(require("./AdvancedTable"));
exports.default = AdvancedTable_1.default;
